import axios from "axios";

const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const API_URL = `${API_BASE}/api/syscom`;

// Normaliza un producto de Syscom a la forma que necesita un renglón de cotización.
export function normalizarProductoSyscom(p) {
  const precios = p.precios || {};
  return {
    productoId: p.producto_id ?? "",
    clave: (p.modelo ?? "").toString().trim().toUpperCase(),
    descripcion: p.titulo ?? "",
    marca: p.marca ?? "",
    imagen: p.img_portada ?? "",
    existencia: Number(p.total_existencia) || 0,
    unidadMedida: p.unidad_de_medida?.nombre || "PZA",
    claveUnidad: p.unidad_de_medida?.clave_unidad_sat || "",
    codSat: p.sat_key || "",
    // El costo real de distribuidor confirmado con el usuario es "precio_descuento".
    precioCompra: Number(precios.precio_descuento) || 0,
    precioLista: Number(precios.precio_lista ?? precios.precio_1) || 0,
  };
}

// Búsqueda estándar por texto/marca/categoría.
export async function buscarProductosSyscom({ busqueda, marca, categoria, pagina = 1, limit = 20 } = {}) {
  const { data } = await axios.get(`${API_URL}/productos`, {
    params: { busqueda: busqueda || undefined, marca: marca || undefined, categoria: categoria || undefined, pagina, limit },
  });
  return {
    cantidad: data.cantidad ?? 0,
    pagina: data.pagina ?? pagina,
    paginas: data.paginas ?? 1,
    productos: (data.productos ?? []).map(normalizarProductoSyscom),
  };
}

// Búsqueda semántica en lenguaje natural (endpoint /productos/busqueda-ia).
export async function buscarProductosSyscomIA({ q, pagina = 1, limit = 20 } = {}) {
  const { data } = await axios.get(`${API_URL}/productos/busqueda-ia`, {
    params: { q, pagina, limit },
  });
  return {
    cantidad: data.cantidad ?? 0,
    pagina: data.pagina ?? pagina,
    paginas: data.paginas ?? 1,
    productos: (data.productos ?? []).map(normalizarProductoSyscom),
  };
}
